import CollapseDetails from './CollapseDetails'
export default CollapseDetails
